import { DefaultTheme, ThemeProps } from 'styled-components';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import kebabCase from 'lodash/kebabCase';
import forEach from 'lodash/forEach';

export const addRootConfig = () => (props: ThemeProps<DefaultTheme>) => {
  const themeConfig: DefaultTheme | null = get(props, 'theme', null);
  if (!themeConfig) {
    return '';
  }
  return reduce(
    Object.keys(themeConfig),
    (acc: string, parameterKey) => {
      const returnCssVar = (key: string, value: string) => `--${kebabCase(key)}:${value};`;
      const parameter = themeConfig[parameterKey as keyof typeof themeConfig];
      forEach(Object.keys(parameter), (optionKey: string) => {
        const key = parameterKey === 'colors' ? optionKey : `${parameterKey}-${optionKey}`;
        acc = acc + returnCssVar(key, parameter[optionKey as keyof typeof parameter]);
      });
      return acc;
    },
    ''
  );
};
